const styles = (theme) => {
    return {
        contentWrapper: {
            height: 'calc(100% - 56px)',
            maxHeight: 'calc(100% - 56px)',
            [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
                height: 'calc(100% - 56px)',
                maxHeight: 'calc(100% - 56px)',
            },
            [theme.breakpoints.up('sm')]: {
                height: 'calc(100% - 64px)',
                maxHeight: 'calc(100% - 64px)',
            },
            width: '100%',
            maxWidth: '100%',
        },
    };
};

export default styles;
